import { useQuery } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';

/**
 * GET /api/eraf/terminology/forbidden-words/:id
 * queryKey: ['terminology', 'forbidden-words', 'detail', id]
 */
export function useForbiddenWord(id: number | undefined) {
  return useQuery({
    queryKey: ['terminology', 'forbidden-words', 'detail', id],
    queryFn: () => terminologyApi.getForbiddenWord(id!),
    enabled: id !== undefined && id > 0,
    staleTime: 30_000,
  });
}
